<template>
  <div class="change-pwd">
    <div class="header">
      <TopBar :title ="$t('mine.mmxg')" />
    </div>
    <div class="content">
      <van-form>
        <van-field
        style="border-top-left-radius: 10px;border-top-right-radius: 10px;"
          v-model="form.oldPassword"
          :name="$t('mmxg.oldPassword')"
          :label="$t('mmxg.oldPassword')"
          :type = "eyesOld ? 'input' :'password'"
          :rightIcon="eyesOld ? 'eye-o' :'closed-eye'"
          @click-right-icon="passwordEyes(1)"
        />

        <van-field
          v-model="form.newPassword"
          :name="$t('mmxg.newPassword')"
          :label="$t('mmxg.newPassword')"
          :rightIcon="eyesNew ? 'eye-o' :'closed-eye'"
          :type = "eyesNew ? 'input' :'password'"
          @click-right-icon="passwordEyes(2)"
        />
        <van-field
        style="border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;"
          v-model="form.confirmedPassword"
          :name="$t('mmxg.qrPassword')"
          :label="$t('mmxg.qrPassword')"
          :rightIcon="eyesRe ? 'eye-o' :'closed-eye'"
          :type = "eyesRe ? 'input' :'password'"
          @click-right-icon="passwordEyes(3)"
        />
      </van-form>
      <!-- <van-icon :name="regPwdCanSee? 'eye-o' : 'closed-eye'" @click="regPwdCanSee = !regPwdCanSee" /> -->
    </div>
    <div class="tips">{{$t('mmxg.wxts')}}</div>
    <div class="btn" style="margin: 16px;">
      <van-button round block type="info" @click="submit">{{$t('mmxg.qrtj')}}</van-button>
    </div>
  </div>
</template>

<script>
  import { accountsChangePassword} from '@/api/api.js';
  import { Notify } from 'vant';
  import TopBar from '@/common/top-bar/index.vue'

  export default {
    name: 'ChangePwd',
    components: {
      TopBar
    },
    data () {
      return {
        form:{
          id:"",
          oldPassword:"",
          newPassword:"",
          confirmedPassword:"",
        },
        eyesOld: false,
        eyesNew: false,
        eyesRe:false,

      }
    },
    methods: {
      passwordEyes(flag){
        if(flag === 1){
          this.eyesOld = !this.eyesOld
        }else if(flag === 2){
          this.eyesNew = !this.eyesNew
        }else{
          this.eyesRe = !this.eyesRe
        }
      },
      onClickLeft(){
        this.$router.go(-1);
      },
      submit(){
        const loginInfo = JSON.parse(localStorage.getItem('LOGIN_INFO'));
        const params = Object.assign(this.form, {id:loginInfo.id})
        accountsChangePassword(params).then(res=>{
          if (res.code === 200) {
            Notify({ type: 'success', message: res.errors[0] });
          }else{
            Notify({ type: 'danger', message: res.errors[0] });
          }
        })
      },

      initPage(){}
    },
    mounted () {
      this.initPage()
    },
    activated () {
    }
  }
</script>

<style lang="stylus" scoped>
  /deep/.change-pwd{
    .van-field__label{
      width:5em
    }
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #F3F3F3;
    .header{
    }
    .content{
      padding: .4rem;
      position: relative;
    }
    .tips{
      padding: .4rem;
      line-height:.4rem;
      color: #C75353;
    }
    .btn{
      button{
        background: #FBC260;
        border: #FBC260;
        font-size: 22px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/changePwd/ChangePwd.vue